/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminOrderPaymentType,
    AdminOrderPaymentTypeFromJSON,
    AdminOrderPaymentTypeFromJSONTyped,
    AdminOrderPaymentTypeToJSON,
} from './AdminOrderPaymentType';
import {
    AdminOrderStatusType,
    AdminOrderStatusTypeFromJSON,
    AdminOrderStatusTypeFromJSONTyped,
    AdminOrderStatusTypeToJSON,
} from './AdminOrderStatusType';

/**
 * 
 * @export
 * @interface AdminCreateProductOrder
 */
export interface AdminCreateProductOrder {
    /**
     * 
     * @type {string}
     * @memberof AdminCreateProductOrder
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateProductOrder
     */
    marketplaceID?: number;
    /**
     * 
     * @type {AdminOrderStatusType}
     * @memberof AdminCreateProductOrder
     */
    orderStatus?: AdminOrderStatusType;
    /**
     * 
     * @type {AdminOrderPaymentType}
     * @memberof AdminCreateProductOrder
     */
    paymentType: AdminOrderPaymentType;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateProductOrder
     */
    salePrice: number;
}



export function AdminCreateProductOrderFromJSON(json: any): AdminCreateProductOrder {
    return AdminCreateProductOrderFromJSONTyped(json, false);
}

export function AdminCreateProductOrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminCreateProductOrder {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'marketplaceID': !exists(json, 'marketplaceID') ? undefined : json['marketplaceID'],
        'orderStatus': !exists(json, 'orderStatus') ? undefined : AdminOrderStatusTypeFromJSON(json['orderStatus']),
        'paymentType': AdminOrderPaymentTypeFromJSON(json['paymentType']),
        'salePrice': json['salePrice'],
    };
}

export function AdminCreateProductOrderToJSON(value?: AdminCreateProductOrder | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': value.createdAt,
        'marketplaceID': value.marketplaceID,
        'orderStatus': AdminOrderStatusTypeToJSON(value.orderStatus),
        'paymentType': AdminOrderPaymentTypeToJSON(value.paymentType),
        'salePrice': value.salePrice,
    };
}

